"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/fourFive/fourFiveUserViewModel',["require", "exports", "knockout", "moment"], function (require, exports, ko, moment) {
    "use strict";

    var FourFiveUserViewModel = function () {
        function FourFiveUserViewModel(fourFiveUser) {
            _classCallCheck(this, FourFiveUserViewModel);

            this.userId = ko.observable('');
            this.forename = ko.observable('');
            this.surname = ko.observable('');
            this.title = ko.observable('');
            this.gender = ko.observable('');
            this.dateOfBirth = ko.observable('');
            this.mobileNumber = ko.observable('');
            this.email = ko.observable('');
            this.postcode = ko.observable('');
            this.vehicleRegistration = ko.observable('');
            this.vehicleName = ko.observable('');
            this.typeId = ko.observable(0);
            this.userType = ko.observable('');
            this.created = ko.observable('');
            this.optOut = ko.observable(false);
            this.displayName = ko.observable('');
            this.optInLeaderBoard = ko.observable(false);
            this.mobileNumberVerified = ko.observable(false);
            this.vehicleRegistrationVerified = ko.observable(false);
            this.qualifiedForLeaderBoard = ko.observable(false);
            this.avatarUrl = ko.observable('');
            this.fullName = ko.pureComputed(this.computeFullName, this);
            this.update(fourFiveUser);
        }

        _createClass(FourFiveUserViewModel, [{
            key: "update",
            value: function update(fourFiveUser) {
                this.userId(fourFiveUser.userId);
                this.forename(fourFiveUser.forename);
                this.surname(fourFiveUser.surname);
                this.title(fourFiveUser.title);
                this.gender(fourFiveUser.gender === 1 ? 'Male' : fourFiveUser.gender === 2 ? 'Female' : '');
                this.dateOfBirth(fourFiveUser.dateOfBirth ? moment(fourFiveUser.dateOfBirth).format('DD/MM/YYYY HH:mm:ss') : '');
                this.mobileNumber(fourFiveUser.mobileNumber);
                this.email(fourFiveUser.email);
                this.postcode(fourFiveUser.postcode);
                this.vehicleRegistration(fourFiveUser.vehicleRegistration);
                this.vehicleName(fourFiveUser.vehicleName);
                this.userType(fourFiveUser.userType);
                this.typeId(fourFiveUser.typeId);
                this.created(fourFiveUser.created ? moment(fourFiveUser.created).format('DD/MM/YYYY HH:mm:ss') : '');
                this.optOut(fourFiveUser.optOut);
                this.displayName(fourFiveUser.displayName);
                this.optInLeaderBoard(fourFiveUser.optInLeaderBoard);
                this.mobileNumberVerified(fourFiveUser.mobileNumberVerified);
                this.vehicleRegistrationVerified(fourFiveUser.vehicleRegistrationVerified);
                this.qualifiedForLeaderBoard(fourFiveUser.qualifiedForLeaderBoard);
                this.avatarUrl(fourFiveUser.avatarUrl);
            }
        }, {
            key: "computeFullName",
            value: function computeFullName() {
                var fullName = '';
                if (this.title()) {
                    fullName += this.title() + ' ';
                }
                if (this.forename()) {
                    fullName += this.forename() + ' ';
                }
                if (this.surname()) {
                    fullName += this.surname() + ' ';
                }
                return fullName;
            }
        }, {
            key: "clear",
            value: function clear() {
                this.userId('');
                this.forename('');
                this.surname('');
                this.title('');
                this.gender('');
                this.dateOfBirth('');
                this.mobileNumber('');
                this.email('');
                this.postcode('');
                this.vehicleRegistration('');
                this.vehicleName('');
                this.typeId(0);
                this.userType('');
                this.created('');
                this.optOut(false);
                this.displayName('');
                this.optInLeaderBoard(false);
                this.mobileNumberVerified(false);
                this.vehicleRegistrationVerified(false);
                this.qualifiedForLeaderBoard(false);
                this.avatarUrl('');
            }
        }]);

        return FourFiveUserViewModel;
    }();

    return FourFiveUserViewModel;
});
//# sourceMappingURL=fourFiveUserViewModel.js.map;
